module.exports = __webpack_public_path__ + "static/media/app_store_download.f1013135.png";